import { render, staticRenderFns } from "./last-track.vue?vue&type=template&id=1fa90f96&scoped=true&"
import script from "./last-track.vue?vue&type=script&lang=js&"
export * from "./last-track.vue?vue&type=script&lang=js&"
import style0 from "./last-track.vue?vue&type=style&index=0&id=1fa90f96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa90f96",
  null
  
)

export default component.exports